import { Button, Form, Select } from "antd";
import { RegisterationText } from "texts/registerationText";
import FormItem from "../_atoms/FormIItem";
import { generalTexts } from "texts/generalTexts";
import { ArrowLeftIconOutline } from "../icons";
import { useEffect, useMemo, useState } from "react";
import { useGetCooperationTypes, useGetPharmacyType } from "api/registration/RegistrationHookReq";

interface Props {
  nextStepHandler: (value) => void;
  prevStepHandler: () => void;
  value: any;
}
const RegisterStep2 = ({ nextStepHandler, prevStepHandler, value }: Props) => {
  const [form] = Form.useForm();

  const [formData, setFormData] = useState({
    pharmacyType: null,
    cooperationType: null,
  });

  useEffect(() => {
    setFormData({ ...formData, ...value });
  }, []);

  const onFinish = () => {
    nextStepHandler(formData);
  };

  const { data: cooperationTypesData } = useGetCooperationTypes();
  const { data: pharmacyTypeData } = useGetPharmacyType();

  const cooperationTypesDataOption = useMemo(() => {
    const vendorList = [];
    cooperationTypesData?.map((item) => {
      vendorList?.push({ label: item?.name, value: item?.id });
    });
    return vendorList;
  }, [cooperationTypesData]);

  const pharmacyTypeDataOption = useMemo(() => {
    const vendorList = [];
    pharmacyTypeData?.map((item) => {
      vendorList?.push({ label: item?.name, value: item?.id });
    });
    return vendorList;
  }, [pharmacyTypeData]);
  return (
    <div className="w-full">
      <p className="text-center text-sm font-medium pb-8">{RegisterationText?.fillFieldsForm}</p>
      <Form initialValues={value} form={form} layout="vertical" onFinish={onFinish} autoComplete="off">
        <FormItem label={RegisterationText?.pharmacyType} name="pharmacyType" rules={[{ required: true }]}>
          <Select options={cooperationTypesDataOption} value={formData?.pharmacyType} className="hover:border-r-0 w-full" size="large" onChange={(e) => setFormData({ ...formData, pharmacyType: e })} />
        </FormItem>
        <FormItem label={RegisterationText?.cooperationType} name="cooperationType" rules={[{ required: true }]}>
          <Select options={pharmacyTypeDataOption} value={formData?.cooperationType} className="hover:border-r-0 w-full" size="large" onChange={(e) => setFormData({ ...formData, cooperationType: e })} />
        </FormItem>
        <div className="flex gap-x-3 w-full">
          <Button type="text" className="bg-white flex justify-center items-center gap-x-1 text-black border-black w-full !px-2" onClick={() => prevStepHandler()} size="large">
            {generalTexts?.returnToBeforePage}
            <ArrowLeftIconOutline width={24} height={24} stroke="black" />
          </Button>
          <Button type="text" className="bg-black flex justify-center items-center gap-x-1 text-white border-black w-full !px-2" htmlType="submit" size="large">
            {generalTexts?.confirmAndContinu}
            <ArrowLeftIconOutline width={24} height={24} stroke="white" />
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default RegisterStep2;
